import { Component, Optional, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerManageService } from '../shared/customer-manage.service';
import { CustomerDetailModalContext, CustomerDetailModalComponent } from '../detail/customer-detail-modal/customer-details-modal.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';

export class DuplicateCustomerContext {
    constructor(public duplicates: any, public customerType: number) {}
}

@Component({
    templateUrl: './add-customer-duplicate-modal.html'
})

export class DuplicateCustomerModalComponent extends BaseComponent {
    context: DuplicateCustomerContext;
    duplicates: any;
    customerType = 1;

    duplicateCount = 0;
    selectedCustomer = -1;

    public duplicateForm: UntypedFormGroup;

    constructor(
        public fb: UntypedFormBuilder,
        public customerService: CustomerManageService,
        public dialogRef: MatDialogRef<DuplicateCustomerModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DuplicateCustomerContext,
        public modalService: MvdModalService
    ) {
        super();

        this.duplicates = data.duplicates;
        this.duplicateCount = this.duplicates.length;
        this.customerType = data.customerType;
    }

    ngOnInit() {
        this.duplicateForm = this.fb.group({
        });
    }

    public cancel() {
        this.dialogRef.close();
    }

    public continue() {
        this.dialogRef.close(this.selectedCustomer);
    }

    public customerSelected(customerNumberId) {
        this.selectedCustomer = customerNumberId;
    }

    public viewCustomer(customerNumberId) {
        // Log Customer View
        this.customerService.logCustomerRequest(customerNumberId, 'View Customer');

        // Show Customer Summary Modal
        const data = new CustomerDetailModalContext(customerNumberId, this.customerType == 1);
        this.modalService.open(CustomerDetailModalComponent, data);
    }
}
